import { render, staticRenderFns } from "./BloodPressure.vue?vue&type=template&id=53c7cd66&scoped=true"
import script from "./BloodPressure.vue?vue&type=script&lang=js"
export * from "./BloodPressure.vue?vue&type=script&lang=js"
import style0 from "./BloodPressure.vue?vue&type=style&index=0&id=53c7cd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7cd66",
  null
  
)

export default component.exports